.quantity {
  display: inline-flex;
  gap: var(--space-1);
  align-items: baseline;
  font-variant-numeric: var(--numeric);
  white-space: nowrap;
}

.quantity[data-missing] {
  color: var(--color-text-subtle);
}

.unit {
  color: var(--color-text-subtle);
  font-size: var(--text-xs);
}

.hiddenUnit {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
